import http from '../interceptors/Intercepter';

const config = {
  headers: {
    'Content-Type': 'application/json',
  },
};

export const retrieveNotifications = async (username) => {
  try {
    const params = { username };

    const { data } = await http.get('/api/notification/view', { ...config, params });

    return [data, null];
  } catch (error) {
    return [null, error];
  }
};

export const acknowledgeNotification = async (username, notificationExternalReference) => {
  try {
    const params = { username, notificationExternalReference };

    const { data } = await http.get('/api/notification/acknowledge', { ...config, params });

    return [data, null];
  } catch (error) {
    return [null, error];
  }
};
